import { pxToRem } from '../utils';

export const brandType = {
  // no match, would be 120_regular
  'display-m': {
    fontWeight: 400,
    fontSize: pxToRem(120),
    letterSpacing: '-0.02rem',
    lineHeight: pxToRem(120),
  },
  // no match, would be 36_medium
  'heading-xxs': {
    fontWeight: 500,
    fontSize: pxToRem(36),
    letterSpacing: '-0.02rem',
    lineHeight: pxToRem(36),
  },
  // no match would be 12_medium
  'body-s': {
    fontWeight: 500,
    fontSize: pxToRem(12),
    letterSpacing: '-0.02rem',
    lineHeight: pxToRem(12),
  },
  // no match, would be 10_medium
  'body-xs': {
    fontWeight: 500,
    fontSize: pxToRem(10),
    letterSpacing: pxToRem(-0.2),
    lineHeight: pxToRem(16),
  },
};

export type BrandType = keyof typeof brandType;
